import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.127 5.539a5 5 0 0 1 2.742 8.656A8.5 8.5 0 0 1 31.3 16.9a1 1 0 0 1-1.601 1.2 6.49 6.49 0 0 0-4.933-2.595L24.5 15.5q-.118 0-.23-.026l-.106-.032-.073-.03a1 1 0 0 1-.585-.803L23.5 14.5a1 1 0 0 1 .33-.743 1 1 0 0 1 .537-.249l.133-.009a3 3 0 1 0-2.947-3.563 1 1 0 0 1-1.965-.375 5 5 0 0 1 5.54-4.023M22 17.5a6 6 0 1 0-9.64 4.769 9 9 0 0 0-4.455 4.293 1 1 0 1 0 1.798.876 7.003 7.003 0 0 1 12.594 0 1 1 0 0 0 1.798-.876 9 9 0 0 0-4.455-4.292A5.99 5.99 0 0 0 22 17.5m-10 0a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-.383-6.769a1 1 0 0 0 .795-1.17 5 5 0 1 0-8.28 4.633A8.5 8.5 0 0 0 .7 16.901 1 1 0 1 0 2.3 18.099 6.49 6.49 0 0 1 7.5 15.5l.09-.004a.999.999 0 0 0 .279-1.926 1 1 0 0 0-.368-.07l-.176-.005a3 3 0 1 1 3.122-3.558 1 1 0 0 0 1.17.794"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPeople = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPeople);
export default Memo;
